<template>
	<div style="height: 100%">
		<div class="buttonBox" v-if="showButton">
			<div>
				<div class="chooseButton searchButton" @click="deviceCheckItemInfoEdit('1')" v-if="MenuRoleList.indexOf('22')>=0"><i
					 class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
				</div>
				<div class="chooseButton searchButton " @click="deviceCheckItemInfoEdit('2')" v-if="MenuRoleList.indexOf('23')>=0"><i
					 class="el-icon-edit-outline"></i>{{$t('btn_15')}}
				</div>
				<div class="chooseButton deleteButton" @click="delEquipmentTypeCheckItem" v-if="MenuRoleList.indexOf('24')>=0"><i
					 class="el-icon-delete"></i>{{$t('btn_16')}}</div>
			</div>
		</div>
		<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row @current-change="handleCurrentChangeTree" border
		 style="width: 100%;margin: 10px 0 10px 0px" height="87%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
			<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
			</el-table-column>
			<el-table-column prop="name" :label="$t('label_143')" align="left" width="300">
				<template slot-scope="scope">
					<span style="font-size: 16px; font-weight: 600;">
						{{scope.row.name}}
					</span>
					<br>
					<popMesBox :popMes="scope.row.content" :hoverMes="scope.row.content" :popWidth="200"></popMesBox>
				</template>
			</el-table-column>
			<el-table-column prop="cycle" :label="$t('label_361')" align="center">
				<template slot-scope="scope">
					<template v-if="scope.row.cycleType=='1'">{{scope.row.cycle=='0'?$t('label_652'):$t('label_531')+scope.row.cycle+$t('label_537')}}</template>
					<template v-if="scope.row.cycleType=='2'">
						{{scope.row.cycle==0?weekendMesOptions[6].label:weekendMesOptions[scope.row.cycle-1].label}}
					</template>
					<template v-if="scope.row.cycleType=='3'">
						{{scope.row.cycle>20?$t('label_238')+scope.row.cycle+$t('label_537'):scope.row.cycle>10?$t('label_242')+scope.row.cycle+$t('label_537'):$t('label_245')+scope.row.cycle+$t('label_537')}}
					</template>
					<template v-if="scope.row.cycleType=='5'">
						{{$t('label_935')+scope.row.cycle.split(',')[0]+$t('label_540')+scope.row.cycle.split(',')[1]+$t('label_542')+scope.row.cycle.split(',')[2]+$t('label_537')}}
					</template>
				</template>
			</el-table-column>
			<el-table-column prop="method" :label="$t('label_365')" align="center">
				<template slot-scope="scope">
					{{checkText(scope.row.method)}}
				</template>
			</el-table-column>
			<el-table-column prop="defaultValue" :label="$t('label_368')" align="center">
				<template slot-scope="scope">
					{{checkDefaultValue(scope.row.defaultValue)}}
				</template>
			</el-table-column>
			<el-table-column prop="sort" v-if="needSort" :label="$t('label_501')" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="moveUp(scope.row, scope.$index)" :disabled="getIndex(scope.$index) === 1"
					 style="font-size: 20px"><i class="el-icon-arrow-up"></i>
					</el-button>
					<el-button type="text" size="small" style="font-size: 20px" @click="moveDown(scope.row, scope.$index)" :disabled="getFormLength(getIndex(scope.$index))"><i
						 class="el-icon-arrow-down"></i>
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
		 @parentMethod="searchPage"></Page>

		<el-dialog v-loading="saveLoading" :title="deviceParamTitle" :visible.sync="dialogDeviceSpot" append-to-body :close-on-click-modal='false'
		 width="800px" top="3%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_143')}}</p>
						<div class="mesInput">
							<el-input v-model="tableDataEdit.name" :disabled="deviceParamTitle==$t('btn_15')" clearable></el-input>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 100px">
						<p><span style="color: #ff0000">*</span>{{$t('label_365')}}</p>
						<div class="mesInput">
							<el-select v-model="tableDataEdit.method" filterable :placeholder="$t('input_65')" clearable>
								<el-option v-for="item in checkList" :key="item.key" :label="item.val" :value="item.key">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_212')}}</p>
					<div class="mesInput" style="width: 640px">
						<el-input type="textarea" :placeholder="$t('input_49')" maxlength="200" show-word-limit v-model="tableDataEdit.content"></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_547')}}</p>
					<div class="mesInput" style="width: 300px;display: flex">
<!--						<p>{{$t('label_550')}}</p>-->
						<el-input :placeholder="$t('input_49')" show-word-limit v-model="tableDataEdit.warningDay" clearable></el-input>
						<p style="padding-left: 10px">{{$t('label_869')}}</p>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_361')}}</p>
					<div class="mesInput" style="display: flex;width: 640px;flex-wrap: wrap">
						<el-radio v-model="tableDataEdit.cycleType" label="2">
							<el-select v-model="tableDataEdit.weekend" style="width: 130px" filterable :placeholder="$t('input_65')" :disabled="tableDataEdit.cycleType!='2'"
							 @change="$forceUpdate()">
								<el-option v-for="item in weekendMesOptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-radio>
						<el-radio v-model="tableDataEdit.cycleType" label="3">
							<el-select style="width: 90px" v-model="tableDataEdit.month" filterable :placeholder="$t('input_65')" :disabled="tableDataEdit.cycleType!='3'"
							 @change="changeSelectMonth">
								<el-option v-for="(item,index) in monthOptions" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
							<el-select style="width: 90px" v-model="tableDataEdit.monthD" @change="$forceUpdate()" :placeholder="$t('input_65')"
							 :disabled="tableDataEdit.cycleType!='3'">
								<el-option v-for="(item,index) in monthDOptions" :key="index" :label="item" :value="item" />
							</el-select>
						</el-radio>
						<el-radio v-model="tableDataEdit.cycleType" label="1">{{$t('label_531')}}
							<el-input
							@input="$forceUpdate()" onkeyup="this.value=this.value.replace(/[^\d]/g,'')" onafterpaste="this.value=this.value.replace(/[^\d]/g,'')"
							@blur="tableDataEdit.cycle = $event.target.value"
							v-model="tableDataEdit.cycle" style="width: 60px" :disabled="tableDataEdit.cycleType!='1'" clearable></el-input>
              {{$t('label_537')}}
						</el-radio>
						<el-radio v-model="tableDataEdit.cycleType" label="5" style="margin: 10px 0">
              {{$t('label_935')}}
							<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.year" :disabled="tableDataEdit.cycleType!='5'"
							 filterable :placeholder="$t('input_65')" clearable>
								<el-option v-for="(item,index) in 10" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
              {{$t('label_540')}}
							<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.yearmonth" :disabled="tableDataEdit.cycleType!='5'"
							 :placeholder="$t('input_65')" clearable>
								<el-option v-for="(item,index) in 12" :key="index" :label="item" :value="item" />
							</el-select>
              {{$t('label_542')}}
							<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.yearmonthD" :disabled="tableDataEdit.cycleType!='5'"
							 :placeholder="$t('input_65')" clearable>
								<el-option v-for="(item,index) in 31" :key="index" :label="item" :value="item" />
							</el-select>
              {{$t('label_537')}}
						</el-radio>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_847')}}</p>
					<div class="mesInput" style="display: flex;width: 640px;padding-top: 13px">
						<el-radio label="1" v-model="tableDataEdit.inputType">{{$t('label_145')}}</el-radio>
						<el-radio label="2" v-model="tableDataEdit.inputType">{{$t('label_149')}}</el-radio>
						<el-radio label="3" v-model="tableDataEdit.inputType">{{$t('label_141')}}</el-radio>
					</div>
				</div>
				<div class="dialogMes">
					<p></p>
					<div class="mesSelect">
						<div>
							<div class="text" style="display: flex;width: 640px;padding-top: 13px;padding-left:15px">
								<p style="width: 170px"><span style="color: #ff0000">*</span>{{$t('label_849')}}</p>
								<p style="width: 160px">{{$t('label_848')}}</p>
								<p style="width: 160px">{{$t('btn_25')}}</p>
							</div>
							<div class="select" style="display: flex;">
								<div class="selectMes" style="width: 450px;border:1px solid #dedede;padding: 10px;height: 160px;overflow:auto;">
									<div class="mes" style="display: flex;margin-bottom: 10px" v-for="(item,index) in checkMesList" v-if="tableDataEdit.inputType!='3'">
										<el-input style="width: 150px" v-model="checkMesList[index].name" clearable></el-input>
										<el-select style="width: 150px;margin-left:20px" v-model="checkMesList[index].check" clearable>
											<el-option v-for="item in oddList" :key="item.val" :label="item.label" :value="item.val"></el-option>
										</el-select>
										<div class="choose" style="padding-top: 13px;margin-left: 20px">
											<el-checkbox v-model="checkMesList[index].default" value="1" @change="changeDefault(index)"></el-checkbox>
										</div>
										<div class="del" v-if="checkMesList.length>1" style="padding-top: 13px;margin-left: 20px;cursor: pointer"
										 @click="delCheckList(index)"><i class="el-icon-remove" style="color: #ff3300;font-size: 20px"></i>
										</div>
									</div>
									<div class="add" style="width: 30px;cursor: pointer" @click="addChooseList" v-if="tableDataEdit.inputType!='3'">
										<i class="el-icon-circle-plus" style="font-size: 22px;color:#0353c1 "></i>
									</div>
								</div>
								<div class="photoStyle">
									<div class="box" @click="choosePhoto?(choosePhoto = false):(choosePhoto = true)" :class="choosePhoto?'choosePhoto':''">
										<div class="choose"></div>
										<i class="el-icon-camera"></i>
									</div>
									<p style="line-height: 20px">{{$t('label_806')}}</p>
									<div class="box" @click="chooseVideo?(chooseVideo = false):(chooseVideo = true)" :class="chooseVideo?'chooseVideo':''">
										<div class="choose"></div>
										<i class="el-icon-video-camera"></i>
									</div>
									<p style="line-height: 20px">{{$t('label_863')}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p v-if="$store.getters.getVersions == 2" style="width: 100px;line-height: 25px">{{$t('label_555')}}(E-SOP)</p>
          <p v-else style="width: 100px;line-height: 25px">{{$t('label_555')}}</p>
					<div class="mesInput">
						<div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;">
							<el-upload v-if="chooseFile==false" class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
							 :show-file-list="false" :http-request="upload">
								<i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
							</el-upload>
							<div v-if="chooseFile==true" style="cursor: pointer;position:relative;">
								<i class="el-icon-success" @click="previewFile" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
								<i class="el-icon-circle-close" @click="delFile" style="font-size: 35px;color: #000000;line-height: 50px;position:absolute;right: -45px"></i>
							</div>
							<!-- <el-tooltip class="item" effect="dark" :content="showName(tableDataEdit.fileId)" placement="bottom">
								<span class="fileName">{{showName(tableDataEdit.fileId)}}</span>
							</el-tooltip> -->
						</div>
						<span>{{showNameList}}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="tableDataEditSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog :visible="showPdf == true  || showPicture == true" :show-close="true" :width="'80%'" append-to-body class="dialog-div-pre-style"
		 :before-close="closePreviewClick" center>
			<div v-if="showPdf == true" class="dialog-body-content-base-style">
				<iframe frameborder="0" :src="$store.getters.getPostUrl+'mes/sysFile/pdf/'+pdfUrl" width='100%' height="600px">
				</iframe>
			</div>
			<div v-else-if="showPicture == true" class="dialog-body-content-base-style">
				<img style="width: 100%;height: 600px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+pictureUrl">
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import file from "@/assets/js/file/file.js";
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'
	import popMesBox from "@/components/list/popover/pop";

	export default {
		name: "deviceParam",
		components: {
			Page,
			popMesBox,
		},
		props: {
			showButton: {
				type: Boolean,
				default: ''
			},
			needSort: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
        saveLoading: false,
				showNameList:'',
				pageNum: 1,
				pageSize: 10,
				chooseFile: false,
				MenuRoleList: [],
				tableDataEdit: {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '2',
					decimals: 0,
					defaultValue: "",
					equipmentTypeId: '',
					fileId: '',
					inputType: '1',
					length: 0,
					method: '',
					name: "",
					needPhoto: 0,
					needPhotoNum: 5,
					needVideo: 0,
					needVideoNum: 1,
					pid: 0,
					remark: "",
					sort: 0,
					unit: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDMes: '1',
				},
				tableDataTreeInfo: {},
				pageCount: 0,
				deviceParamTitle: this.$t('btn_14'),
				dialogDeviceSpot: false,
				choosePhoto: false,
				chooseVideo: false,
				showPdf: false,
				showPicture: false,
				tableData: [],
				oddList: [{
					val: '0',
					label: this.$t('label_864')
				}, {
					val: '1',
					label: this.$t('label_105')
				}],
				checkMesList: [{
					name: '',
					check: '',
					default: ''
				}],
				chooseDefault: '',
				allDeviceData: [],
				checkList: [],
        weekendMesOptions: [{
          value: '1',
          label: this.$t('label_719')
        }, {
          value: '2',
          label: this.$t('label_721')
        }, {
          value: '3',
          label: this.$t('label_723')
        }, {
          value: '4',
          label: this.$t('label_725')
        }, {
          value: '5',
          label: this.$t('label_728')
        }, {
          value: '6',
          label: this.$t('label_730')
        }, {
          value: '0',
          label: this.$t('label_716')
        }, ],
				monthDOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
				monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
				monthOptionsObj: {
					// '每月初': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
					// '每月中': ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
					// '每月末': ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
				},
				searchDataList: {
					equipmentTypeId: ''
				},
				fileList: []
			}
		},
		methods: {
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			changeSelectMonth() {
				this.tableDataEdit.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataEdit.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataEdit.month]
					}
				}
			},
			newMes(id) {
				this.searchDataList.equipmentTypeId = id;
			},
			handleExceed(files, fileList) {
				this.$message.warning(this.$t('msg_151') + ',' +  this.$t('msg_152') + files.length +  this.$t('msg_153') + ',' +  this.$t('msg_154') + (files.length + fileList.length) + this.$t('msg_153'));
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
				console.log(this.tableDataTreeInfo)
			},
			addChooseList() {
				this.checkMesList.push({
					name: '',
					check: '',
					default: ''
				})
			},
			handlePreview(file) {

			},
			changeDefault(index) {
				let that = this;
				if (this.tableDataEdit.inputType == "1") {
					this.checkMesList.forEach(function(value, index2, array) {
						if (index != index2) {
							that.checkMesList[index2].default = false;
						}
					});
				}
			},
			delFile() {
				this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
					confirmButtonText: this.$t('label_100'),
					cancelButtonText: this.$t('btn_1'),
					type: 'warning'
				}).then(() => {
					this.chooseFile = false;
					this.tableDataEdit.fileId = "";
				}).catch(() => {

				});
			},
			searchPage(param) {
				var dataParam = this.searchDataList;
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.$refs['pageModel'].setCurrent(this.pageNum);
				this.getEquipmentTypeCheckInfo(newParam)
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param)
			},
			checkText(type) {
				let typeText = type.toString();
				var data = this.checkList.filter(function(item) {
					return item.key == typeText;
				});
				if (data != '') {
					return data[0].val
				}
			},
			checkDefaultValue(value) {
				let list = JSON.parse(value);
				let text = '';
				var count = 1;
				list.forEach(function(value, index2, array) {
					if (value.check == "1") {
						if (count == 1) {
							text += value.name;
						} else {
							text += ',' + value.name;
						}
						count++;
					}
				});
				return text
			},
			moveUp(item, index) {
				if (index === 0) {
					let param = {
						id: item.id,
						versionFlag: 0,
						upDown: 0
					}
					file.sortEquipmentTypeInspectionInfo2(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					let param = {
						id: item.id,
						sort: item.sort,
						id2: this.tableData[index - 1].id,
						sort2: this.tableData[index - 1].sort
					}
					file.sortEquipmentTypeInspectionInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				}

			},
			// 下移
			moveDown(item, index) {
				if (index === 9) {
					let param = {
						id: item.id,
						versionFlag: 0,
						upDown: 1
					}
					file.sortEquipmentTypeInspectionInfo2(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					let param = {
						id: item.id,
						sort: item.sort,
						id2: this.tableData[index + 1].id,
						sort2: this.tableData[index + 1].sort
					}
					file.sortEquipmentTypeInspectionInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				}

			},
			getFormLength(index) {
				if (index === this.pageCount) return true;
				else return false;
			},
			getCheckList() {
        file.getByDictIdALL({dictId: 2, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.checkList = data.data;
          }
        }).catch((response) => {
          console.log(response)
        })
				// file.getCheckList().then((response) => {
				// 	const data = response.data;
				// 	if (data.code == "1") {
				// 		this.checkList = data.data;
				// 	}
				// }).catch((response) => {
				// 	console.log(response)
				// })
			},
			handleClose() {
				this.dialogDeviceSpot = false;
				this.tableDataEdit = {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '2',
					decimals: 0,
					defaultValue: "",
					equipmentTypeId: '',
					fileId: '',
					inputType: '1',
					length: 0,
					method: '',
					name: "",
					needPhoto: 0,
					needPhotoNum: 5,
					needVideo: 0,
					needVideoNum: 1,
					pid: 0,
					remark: "",
					sort: 0,
					unit: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDMes: '1',
				}
				this.checkMesList = [{
					name: '',
					check: '',
					default: ''
				}]

				this.choosePhoto = false;
				this.chooseVideo = false;
			},
			delCheckList(index) {
				this.checkMesList.splice(index, 1);
			},
			checkTypeText(type) {
        if (type == '1') {
          return this.$t('label_145')
        }
        if (type == '2') {
          return this.$t('label_149')
        }
        if (type == '3') {
          return this.$t('label_141')
        }
        if (type == '4') {
          return this.$t('label_138')
        }
			},
			getEquipmentTypeCheckInfo(param) {
				file.getEquipmentTypeInspectionInfo(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			deviceCheckItemInfoEdit(title) {
				if (title == '2') {
					if (Object.keys(this.tableDataTreeInfo).length > 0) {
						file.getEquipmentTypeInspectionInfoMes(this.tableDataTreeInfo.id).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.deviceParamTitle = this.$t('btn_15');
								this.tableDataEdit = data.data;
								if (this.tableDataEdit.cycleType == '1') {
									this.tableDataEdit.cycleType = '1';
								} else if (this.tableDataEdit.cycleType == '2') {
									this.tableDataEdit.weekend = this.tableDataEdit.cycle
									this.tableDataEdit.cycle = '';
									this.tableDataEdit.cycleType = '2';
								} else if (this.tableDataEdit.cycleType == '3') {
									let monthss = Number(this.tableDataEdit.cycle);
									if (monthss > 20) {
										this.tableDataEdit.month = this.$t('label_238')
									} else if (monthss > 10) {
										this.tableDataEdit.month = this.$t('label_242')
									} else {
										this.tableDataEdit.month = this.$t('label_245')
									}
									this.tableDataEdit.monthD = this.tableDataEdit.cycle
									this.tableDataEdit.cycleType = '3';
									this.tableDataEdit.cycle = '';
								} else if (this.tableDataEdit.cycleType == '5') {
									this.tableDataEdit.year = this.tableDataEdit.cycle.split(',')[0];
									this.tableDataEdit.yearmonth = this.tableDataEdit.cycle.split(',')[1];
									this.tableDataEdit.yearmonthD = this.tableDataEdit.cycle.split(',')[2];
									this.tableDataEdit.cycle = '';
								}
								//  else {
								// 	this.tableDataEdit.monthDMes = this.tableDataEdit.cycle;
								// 	this.tableDataEdit.cycleType = '4';
								// }
								this.tableDataEdit.inputType = this.tableDataEdit.inputType.toString();
								this.tableDataEdit.method = this.tableDataEdit.method.toString();
								this.tableDataEdit.fileId = data.data.fileId
								if (this.tableDataEdit.fileId != "" && this.tableDataEdit.fileId != null) {
									this.chooseFile = true;
									this.showName(this.tableDataEdit.fileId)
								} else {
									this.chooseFile = false;
									this.showNameList='';
								}
								this.checkMesList = JSON.parse(this.tableDataEdit.defaultValue)
								this.choosePhoto = this.tableDataEdit.needPhoto ? true : false
								this.chooseVideo = this.tableDataEdit.needVideo ? true : false;
								this.dialogDeviceSpot = true;
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					} else {
						utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
					}
				} else {
					this.dialogDeviceSpot = true;
					this.deviceParamTitle = this.$t('btn_14');
					this.chooseFile = false;
					this.showNameList='';
				}
			},
			tableDataEditSave() {
        this.saveLoading = true;
				if (this.tableDataEdit.name == null || this.tableDataEdit.name == '') {
					utils.messageAlert(this.$t('msg_118'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (RegExp("((?=[\x21-\x7e]+)[^A-Za-z0-9])").test(this.tableDataEdit.name)) {
					utils.messageAlert(this.$t('msg_119'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.method == null || this.tableDataEdit.method == '') {
					utils.messageAlert(this.$t('msg_120'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.warningDay == null || this.tableDataEdit.warningDay.toString() == '') {
					utils.messageAlert(this.$t('msg_121'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (isNaN(parseInt(this.tableDataEdit.warningDay))) {
					utils.messageAlert(this.$t('msg_122'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.cycleType == null || this.tableDataEdit.cycleType == '') {
					utils.messageAlert(this.$t('msg_81'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.cycleType == "1") {
					if (isNaN(parseInt(this.tableDataEdit.cycle))) {
						utils.messageAlert(this.$t('msg_123'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return;
					}
				}
				if (this.tableDataEdit.inputType == null || this.tableDataEdit.inputType == '') {
					utils.messageAlert(this.$t('msg_82'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.inputType == '1' || this.tableDataEdit.inputType == '2') {
					for (var i = 0; i < this.checkMesList.length; i++) {
						if (this.checkMesList[i].name == '' || this.checkMesList[i].name == null) {
							utils.messageAlert(this.$t('msg_82'), this.$t('label_358'), this.$t('label_100'));
              this.saveLoading = false;
							return;
						}
					}
				}
				if (this.deviceParamTitle == this.$t('btn_14')) {
					this.tableDataEdit.sort = this.pageCount + 1;
					this.tableDataEdit.equipmentTypeId = this.searchDataList.equipmentTypeId;
					if (this.tableDataEdit.cycleType == '1') {
						// this.tableDataEdit.cycle = '1'
					} else if (this.tableDataEdit.cycleType == '2') {
						this.tableDataEdit.cycle = this.tableDataEdit.weekend
					} else if (this.tableDataEdit.cycleType == '3') {
						this.tableDataEdit.cycle = this.tableDataEdit.monthD
					} else if (this.tableDataEdit.cycleType == '5') {
						this.tableDataEdit.cycle = this.tableDataEdit.year + ',' + this.tableDataEdit.yearmonth + ',' + this.tableDataEdit
							.yearmonthD;
					}
					// else {
					// 	this.tableDataEdit.cycle = this.tableDataEdit.monthDMes;
					// 	this.tableDataEdit.cycleType = '1';
					// }
					this.tableDataEdit.defaultValue = JSON.stringify(this.checkMesList)
					this.tableDataEdit.needPhoto = this.choosePhoto ? 1 : 0;
					this.tableDataEdit.needVideo = this.chooseVideo ? 1 : 0;
					file.saveEquipmentTypeInspectionInfo(this.tableDataEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.search();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				} else {
					if (this.tableDataEdit.cycleType == '1') {
						// this.tableDataEdit.cycle = '1'
					} else if (this.tableDataEdit.cycleType == '2') {
						this.tableDataEdit.cycle = this.tableDataEdit.weekend
					} else if (this.tableDataEdit.cycleType == '3') {
						this.tableDataEdit.cycle = this.tableDataEdit.monthD
					} else if (this.tableDataEdit.cycleType == '5') {
						this.tableDataEdit.cycle = this.tableDataEdit.year + ',' + this.tableDataEdit.yearmonth + ',' + this.tableDataEdit
							.yearmonthD;
					}
					//  else {
					// 	this.tableDataEdit.cycle = this.tableDataEdit.monthDMes;
					// 	this.tableDataEdit.cycleType = '1';
					// }
					this.tableDataEdit.defaultValue = JSON.stringify(this.checkMesList)
					this.tableDataEdit.needPhoto = this.choosePhoto ? 1 : 0;
					this.tableDataEdit.needVideo = this.chooseVideo ? 1 : 0;
					file.saveEquipmentTypeInspectionInfoEdit(this.tableDataEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.search();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				}
				this.tableDataEdit = {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '2',
					decimals: 0,
					defaultValue: "",
					equipmentTypeId: '',
					fileId: '',
					inputType: '1',
					length: 0,
					method: '',
					name: "",
					needPhoto: 0,
					needPhotoNum: 5,
					needVideo: 0,
					needVideoNum: 1,
					pid: 0,
					remark: "",
					sort: 0,
					unit: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDMes: '1',
				}
				this.checkMesList = [{
					name: '',
					check: '',
					default: ''
				}]

				this.choosePhoto = false;
				this.chooseVideo = false;
			},
			delEquipmentTypeCheckItem() {
				let param = this.tableDataTreeInfo.id;
				let that = this;
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						file.delEquipmentTypeInspectionInfo(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								that.search();
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			showName(row) {
							file.selectFileName(row).then((response) => {
								const data = response.data;
								if (data.code == "1") {
									this.showNameList = data.data;
								}
							}).catch((response) => {
								console.log(response)
							})
							// return this.showNameList[row]
						},
			previewFile() {
				file.selectFileType(this.tableDataEdit.fileId).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						let type = data.data;
						if (type.indexOf(".pdf") != -1) {
							this.pdfUrl = this.tableDataEdit.fileId;
							this.showPdf = true
						} else if (type.indexOf(".jpg") != -1 || type.indexOf(".png") != -1 || type.indexOf(".jpeg") != -1) {
							this.pictureUrl = this.tableDataEdit.fileId;
							this.showPicture = true
						} else {
							this.$message(this.$t('msg_9'))
						}
					} else {
						this.$message(this.$t('msg_10'))
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			closePreviewClick() {
				if (this.showPdf == true) {
					this.showPdf = false
				} else if (this.showPicture == true) {
					this.showPicture = false
				}
			},
			upload(file1) {
				var formData = new FormData();
				formData.append('file', file1.file);
				file.upload(formData).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.tableDataEdit.fileId = data.data
						this.showName(data.data)
						this.$message({
							message: this.$t('msg_15'),
							type: 'success'
						});
						this.chooseFile = true;
					} else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
		},
		created() {
			this.getCheckList();
			this.MenuRoleList = this.$store.getters.getMenu;
      this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
      this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']);
      this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']);
		}
	}
</script>

<style scoped>
	.photoStyle {
		display: flex;
		justify-content: center;
		width: 100px;
		flex-wrap: wrap;
		text-align: center
	}

	.photoStyle .box {
		background: #43c477;
		width: 50px;
		height: 50px;
		text-align: center;
		border-radius: 5px;
		overflow: hidden;
		position: relative;
	}

	.photoStyle .box i {
		font-size: 35px;
		color: #ffffff;
		line-height: 50px;
		cursor: pointer;
	}

	.photoStyle .box.choosePhoto .choose {
		width: 0;
		height: 0;
		border-top: 25px solid red;
		border-left: 25px solid transparent;
		position: absolute;
		top: 0;
		right: 0;
	}

	.photoStyle .box.chooseVideo .choose {
		width: 0;
		height: 0;
		border-top: 25px solid red;
		border-left: 25px solid transparent;
		position: absolute;
		top: 0;
		right: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/inspectionItem.vue